import { EventTypes } from './../EventTypes';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { TweenMax, Quint, TimelineMax, Back, Sine } from 'gsap';

@Component({
	selector: 'app-preloader',
	templateUrl: './preloader.component.html',
	styleUrls: ['./preloader.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PreloaderComponent implements OnInit, OnDestroy {

	tl: TimelineMax = new TimelineMax({paused: true});

	constructor() {
		AppEventDispatcher.listen(EventTypes.PRELOAD, (data) => {
			if (data.show) {
				// this.show(data.element, data.delay);
			} else {
				// this.hide(data.element, data.delay);
			}
		});
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		// AppEventDispatcher.removeListener(EventTypes.PRELOAD);
	}

	show(element, delay = 0) {
		this.tl = new TimelineMax({delay: delay});
		if (element) {
			this.tl.add(TweenMax.to(element, .8, {scale: .92, force3D: true,  ease: Quint.easeOut}), 0);
		}
		this.tl.add(TweenMax.to('[data-component="preloader"]', .3, { autoAlpha: 1, ease: Quint.easeOut}), .4);
		this.tl.add(TweenMax.to('[data-component="preloader"] .spinner', .6, { scale: 1, ease: Back.easeOut}), 1);
		$("body").css("overflow", "hidden");
	}

	hide(element, delay = 0) {
		this.tl = new TimelineMax({delay: delay});
		this.tl.add(TweenMax.to('[data-component="preloader"] .spinner', .3, { scale: 0, ease: Quint.easeOut}), 0);
		this.tl.add(TweenMax.to('[data-component="preloader"]', .3, { autoAlpha: 0, ease: Quint.easeOut}), .4);
		if (element) {
			this.tl.add(TweenMax.to(element, .8, {scale: 1, force3D: true,  ease: Quint.easeOut}), .8);
		}
		$("body").css("overflow", "auto");
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/preloader/preloader.component.ts